<div *ngIf="servico">
  <form (ngSubmit)="onSubmit()" [formGroup]="servicoForm">
    <div class="form_wrapper">
      <label>Preencha no quadro abaixo as informações da sua solicitação
        <i>(OBRIGATÓRIO)</i>:</label>
      <textarea pInputTextarea rows="5" formControlName="informacoes" [placeholder]="servico.informacoes"
        class="w-full lg:w-9" style="resize: none" maxlength="4000"></textarea>

      <ng-container *ngFor="let campo of servico?.servicoFormulario">
        <label for="campo_{{ campo.id }}">{{ campo.label }}</label>

        <p-dropdown [formControlName]="campo.id" [options]="campo.servicoValores" optionLabel="valor"></p-dropdown>
      </ng-container>
    </div>

    <div class="form_arquivos">
      <h4 class="subtitulo">
        DOCUMENTOS IDENTIFICAÇÃO DIGITALIZADOS <i>(OBRIGATÓRIO)</i>
      </h4>

      <p-fileUpload #arquivoDeIdentificacao [disabled]="loading" [showUploadButton]="false"
        [fileLimit]="arquivosManager.NUMERO_MAXIMO_ARQUIVOS_IDENTIFICACAO" [multiple]="true"
        [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS" chooseLabel="Selecionar arquivos"
        cancelLabel="Limpar arquivos" class="file" accept="image/*,application/pdf"
        invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
        invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
        invalidFileTypeMessageSummary="Tipo de arquivo inválido"
        invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
        invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
        invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}" (onSelect)="
          arquivosManager.onFileSelect(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_IDENFITICACAO
          )
        " (onRemove)="
          arquivosManager.onFileRemove(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_IDENFITICACAO
          )
        " (onClear)="
          arquivosManager.onClearFiles(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_IDENFITICACAO
          )
        ">
        <ng-template pTemplate="toolbar">
          <div *ngIf="
              servico.descricaoDocumentoIdentificacao;
              else defaultDocuments
            " [innerHTML]="servico.descricaoDocumentoIdentificacao"></div>

          <ng-template #defaultDocuments>
            <ul class="py-3">
              <li>Para pessoa física: CPF e RG ou CNH</li>
              <li>
                Para pessoa jurídica: CNPJ, Contrato Social, CPF e RG ou CNH do
                representante legal
              </li>
            </ul>
          </ng-template>
          <div class="flex flex-column items-start">
            <sub>É PERMITIDO SELECIONAR ATÉ 4 ARQUIVOS</sub>
            <sub style="color: red"><i>Envio Obrigatório</i></sub>
          </div>
        </ng-template>
      </p-fileUpload>

      <p-fileUpload #declaracaoVeracidade *ngIf="!mostrarTermoAceite" [disabled]="loading" [showUploadButton]="false"
        [fileLimit]="1" [multiple]="false" [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS"
        chooseLabel="Selecionar arquivos" cancelLabel="Limpar arquivos" class="file" accept="image/*,application/pdf"
        invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
        invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
        invalidFileTypeMessageSummary="Tipo de arquivo inválido"
        invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
        invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
        invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}" (onSelect)="
          arquivosManager.onFileSelect(
            $event,
            arquivosManager.DECLARACAO_VERACIDADE_ACEITE
          )
        " (onRemove)="
          arquivosManager.onFileRemove(
            $event,
            arquivosManager.DECLARACAO_VERACIDADE_ACEITE
          )
        " (onClear)="
          arquivosManager.onClearFiles(
            $event,
            arquivosManager.DECLARACAO_VERACIDADE_ACEITE
          )
        ">
        <ng-template pTemplate="toolbar">
          <ul class="py-3">
            <li>
              Declaração de Veracidade/Declaração de Aceite
            </li>
          </ul>
          <sub style="color: red"><i>Envio Obrigatório</i></sub>
        </ng-template>
      </p-fileUpload>

      <p-fileUpload #fotoIdentificacao *ngIf="habilitarFotoIdentificacao && servico.solicitarFotoIdentificacao"
        [disabled]="loading" [showUploadButton]="false" [fileLimit]="1" [multiple]="false"
        [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS" chooseLabel="Selecionar arquivos"
        cancelLabel="Limpar arquivos" class="file" accept="image/*,application/pdf"
        invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
        invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
        invalidFileTypeMessageSummary="Tipo de arquivo inválido"
        invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
        invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
        invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}" (onSelect)="
          arquivosManager.onFileSelect(
            $event,
            arquivosManager.ANEXO_FOTO_IDENTIFICACAO
          )
        " (onRemove)="
          arquivosManager.onFileRemove(
            $event,
            arquivosManager.ANEXO_FOTO_IDENTIFICACAO
          )
        " (onClear)="
          arquivosManager.onClearFiles(
            $event,
            arquivosManager.ANEXO_FOTO_IDENTIFICACAO
          )
        ">
        <ng-template pTemplate="toolbar">
          <ul class="py-3">
            <li>
              Para pessoa física: foto segurando o documento de identificação
            </li>
            <li>
              Para pessoa jurídica: foto do representante legal segurando o
              documento de identificação
            </li>
          </ul>
          <sub style="color: red"><i>Envio Obrigatório</i></sub>
        </ng-template>
      </p-fileUpload>

      <h4 class="subtitulo">DOCUMENTOS ESPECÍFICOS DIGITALIZADOS</h4>
      <ng-container *ngFor="let campo of servico?.servicoAnexos">
        <p-fileUpload [disabled]="loading" [showUploadButton]="false" [fileLimit]="1"
          [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS" chooseLabel="Selecionar arquivo"
          cancelLabel="Limpar arquivos" class="file" accept="image/*,application/pdf"
          invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
          invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
          invalidFileTypeMessageSummary="Tipo de arquivo inválido"
          invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
          invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
          invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}"
          (onSelect)="arquivosManager.onFileSelect($event, campo.nomeAnexo)"
          (onRemove)="arquivosManager.onFileRemove($event, campo.nomeAnexo)"
          (onClear)="arquivosManager.onClearFiles($event, campo.nomeAnexo)">
          <ng-template pTemplate="toolbar">
            <div class="py-3">{{ campo.label }}</div>
            <sub style="color: red"><i *ngIf="campo.envioObrigatorio">Envio Obrigatório</i></sub>
          </ng-template>
        </p-fileUpload>
      </ng-container>
      <h4 class="subtitulo">DOCUMENTOS COMPLEMENTARES DIGITALIZADOS</h4>

      <p-fileUpload [disabled]="loading" [showUploadButton]="false" [fileLimit]="3" [multiple]="true"
        [customUpload]="true" [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS" chooseLabel="Selecionar arquivos"
        cancelLabel="Limpar arquivos" class="file" accept="image/*,application/pdf"
        invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
        invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
        invalidFileTypeMessageSummary="Tipo de arquivo inválido"
        invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
        invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
        invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}" (onSelect)="
          arquivosManager.onFileSelect(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_OUTROS
          )
        " (onRemove)="
          arquivosManager.onFileRemove(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_OUTROS
          )
        " (onClear)="
          arquivosManager.onClearFiles(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_OUTROS
          )
        ">
        <ng-template pTemplate="toolbar">
          <ul class="py-3">
            <li>
              Quando for representante (terceiro), apresentar:
              <ul>
                <li>Procuração do Usuário/Proprietário (Pessoa Física); ou</li>
                <li>Procuração do Sócio Administrador (Pessoa Jurídica).</li>
              </ul>
            </li>

            <li>
              Para proprietário falecido e imóvel em inventário*:
              <ul>
                <li>
                  Termo de Inventário (caso o inventário não esteja finalizado)
                  ou
                </li>
                <li>Escritura de Inventário e Partilha de Bens</li>
                <li>
                  Documento de identificação do requerente (CPF e RG ou CNH)
                </li>
              </ul>

              <i style="font-size: 14px">
                * Havendo mais de um herdeiro responsável, a vinculação poderá
                ser solicitada por qualquer um dos apontados como proprietário
                sem necessidade de autorização dos demais
              </i>
            </li>

            <li>
              Para proprietário falecido e imóvel sem inventário:
              <ul>
                <li>Certidão de óbito em inteiro teor</li>
                <li>
                  Documento de identificação do requerente (CPF e RG ou CNH)
                </li>
                <li>
                  Documento de anuência dos demais herdeiros do falecido
                  constantes na Certidão de Óbito apresentada, através de
                  procuração com firma reconhecida em cartório ou assinatura
                  eletrônica
                </li>
              </ul>
            </li>
          </ul>
          <sub>É PERMITIDO SELECIONAR ATÉ 3 ARQUIVOS</sub>
        </ng-template>
      </p-fileUpload>
    </div>
    <button pButton type="submit" [disabled]="
        servicoForm.invalid ||
        servicoForm.disabled ||      
        !isArquivosObrigatoriosSelecionados()
      " [loading]="loading" label="Próximo" class="botao-proximo"></button>
  </form>

  <p-dialog [closable]="false" [modal]="true" [visible]="!understandTermoAceite && openTermoAceite()"
    styleClass="w-full m-2 max-h-screen md:w-5" header="Termo de Aceite" (onShow)="handleShowTermoAceite($event)"
    #termoAceiteDialog>
    <pre style="font-family: 'Open Sans', sans-serif; white-space: pre-wrap"
      [innerHTML]="servico.termoAceiteDescricao"></pre>

    <ng-template pTemplate="footer">
      <div class="w-full text-left">
        <p-checkbox [(ngModel)]="understandTermoAceite" [binary]="true" inputId="understandTermoAceite"
          [disabled]="disableTermoAceite" [label]="servico.termoAceite">
        </p-checkbox>
      </div>
    </ng-template>
  </p-dialog>
</div>